// Import Stimulus Controller
import { Controller } from "stimulus";

export default class extends Controller {
    static targets = ["free-item"];

    connect() {
        if (this.shouldDisplayAlerts()) {
            this.displayAlerts();
            this.setAlertCookie();
        } else {
            this.hideAllAlerts();
        }
    }

    close(event) {
        const alert = event.target.closest('.flash-alert');
        if (alert) {
            this.hideAlert(alert);
            if (alert.classList.contains('free-items-popup')) {
                this.setFreeItemsDismissedCookie();
            }
        }
    }

    // Helper Methods

    displayAlerts() {
        this.alertTargets.forEach((alert, index) => {
            const delay = index * 500;
            this.showAlertWithDelay(alert, delay);
            this.autoHideAlert(alert,  10000);
        });
    }

    showAlertWithDelay(alert, delay) {
        setTimeout(() => {
            alert.classList.add('active');
        }, delay);
    }

    autoHideAlert(alert, delay) {
        setTimeout(() => {
            this.hideAlert(alert);
        }, delay);
    }

    hideAlert(alert) {
        alert.classList.remove('active');
        setTimeout(() => {
            alert.style.display = 'none';
        }, 500);
    }

    hideAllAlerts() {
        this.alertTargets.forEach(alert => {
            alert.style.display = 'none';
        });
    }

    shouldDisplayAlerts() {
        return !this.hasAlertCookie() && !this.getFreeItemsDismissedCookie();
    }

    hasAlertCookie() {
        return document.cookie.split('; ').some(row => row.startsWith('BELERTS=true'));
    }

    setAlertCookie() {
        const expires = new Date(Date.now() + 30 * 60 * 1000).toUTCString();
        document.cookie = `BELERTS=true; expires=${expires}; path=/`;
    }

    getFreeItemsDismissedCookie() {
        var name = "FREEITEMS_DISMISSED=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    setFreeItemsDismissedCookie() {
        let d = new Date();
        d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = "FREEITEMS_DISMISSED=1;" + expires + ";path=/";
    }
}
